export default "__VITE_ASSET__CpBvSIMW__"